import * as React from "react";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import DropdownApi from "../../components/DropdownApi";
import {
  siteEquipmentAdd,
  siteEquipmentUpdate,
  siteSetupEmployeeAdd,
} from "../../service/siteService";
import { Grid } from "@mui/material";
import MultiDropdownApi from "../../components/MultiDropdownApi";

export default function SiteSetupEmployeeAdd(modalProps: any) {
  const record = modalProps.record;

  const [employees, setEmployees] = React.useState(record?.employee || []);

  const siteId = modalProps.siteId;
  const appointmentId = modalProps.id;

  async function EquipmentAdd() {
    let createObject: any = {
      siteId,
      appointment: appointmentId,
      employee: employees,
    };
    modalProps.setGlobalLoader(true);
    siteSetupEmployeeAdd(createObject).then((r: any) => {
      modalProps.setGlobalLoader(false);
      modalProps.toast.current.show({
        severity: "success",
        summary: "Employee Assign Successfully",
        life: 3000,
      });
      modalProps.setReload(!modalProps.reload);
      modalProps.setVisible(false);
    });
    return;
  }

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MultiDropdownApi
            apiPath="employee-select"
            optionLabel="full_name"
            optionValue="id"
            label="Employees"
            selectedData={employees}
            setSelectedData={setEmployees}
            queryParams={{ appointmentId }}
          />
        </Grid>
      </Grid>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{ position: "absolute", fontSize: "small", right: 0, color: "#2dd36f" }}
            onClick={() => EquipmentAdd()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
